import React from "react";
import { Button } from "primereact/button";
import updateIconImg from "../../../Assets/updateIconImg.png";
import { FORM_MODE } from "../../../Shared/Constant/MasterFormConstants";
import UserRoles from "../../../Shared/Constant/UserRoles";
import { useTranslation } from "react-i18next";

function getShowUpdateButton(showButton, currentRole) {
  return (
    showButton && showButton.length > 0 && showButton.includes(currentRole)
  );
}
const areAllValuesSame = (arr, prop) => {
  /** Get the value of the property for the first object in the array */
  const refVal = arr[0][prop];
  /** Check if all other objects have the same value for the property */
  return arr.every((el) => el[prop] === refVal);
};

const checkFieldsEqual = (selectedItems, fields) => {
  if (selectedItems.length === 1) {
    return true;
  }

  let allEqual = true;
  let checking = false;

  // checking status equality for all selected items to update
  if (!areAllValuesSame(selectedItems, "status")) {
    return false;
  }

  fields &&
    fields.forEach((field) => {
      if (field.showWhenMultiUpdate) {
        checking = true;
        const checkEach = !areAllValuesSame(selectedItems, field.name);
        if (checkEach) {
          allEqual = false;
        }
      }
    });

  return allEqual && checking;
};

const UpdateButton = (props) => {
  const { showButton, currentRole } = props;
  const { t } = useTranslation("master");
  if (!getShowUpdateButton(showButton, currentRole)) {
    return null;
  }
  const {
    setVisible,
    setFormMode,
    selectedItems,
    formConfig,
    setEnableFileDocument,
  } = props;

  const { title, fields } = formConfig;

  const disabled = () => {
    if (!selectedItems || selectedItems.length === 0) {
      return true;
    }
    if (currentRole === UserRoles.SUPERADMIN) {
      return !checkFieldsEqual(selectedItems, fields);
    }
    return (
      !checkFieldsEqual(selectedItems, fields) ||
      selectedItems[0].status !== "Valid"
    );
  };

  const onUpdate = () => {
    setEnableFileDocument(false);
    setVisible(true);
    if (selectedItems[0].status === "Valid") {
      setFormMode(FORM_MODE.UPDATE);
    } else {
      setFormMode(FORM_MODE.APPROVE);
    }
  };

  return (
    <Button
      data-testid="update-district-data"
      className="btn btn-primary"
      label={t("Update")}
      severity="info"
      onClick={onUpdate}
      icon={<img src={updateIconImg} alt="Update icon" />}
      outlined
      disabled={disabled()}
      tooltip={`Update ${title} data`}
      tooltipOptions={{ position: "bottom", event: "both" }}
    />
  );
};
export default UpdateButton;
